import React from 'react';
import './Secondary.scss';
import WatchButton from './WatchButton/WatchButton';
import PlaylistButton from './PlaylistButton/PlaylistButton';
import ChannelsButton from './ChannelsButton/ChannelsButton';

const Secondary = props => {
  const { channel } = props;
  return (
    <div className="Secondary">
      <WatchButton channel={channel} />
      <PlaylistButton />
      <ChannelsButton />
    </div>
  );
};

export default Secondary;
